
import * as types from '../../mutation-types'
import {setItems, ftAPI} from '../../../util/helpers'
import merge from 'deepmerge'

export default function (clubSettings) {
  const state = merge({
    // Add club settings used by all apps here
    DINING_ALLOW_MEMBER_UPDATE_OF_SPECIAL_REQUESTS: false
  }, clubSettings)

  const mutations = {
    [types.SET_CLUB_SETTINGS] (state, settings) {
      setItems(state, settings, state)
      if (ftAPI()) ftAPI().setLastClubSettings(state)
    }
  }

  return {
    state,
    mutations
  }
}
